var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"justify-center",attrs:{"color":"transparent"}},[_c('p',{staticStyle:{"color":"#555"}},[_c('small',[_vm._v("© "+_vm._s((new Date()).getFullYear())+" - Todos os direitos reservados a Fin-X")])])])}
var staticRenderFns = []

export { render, staticRenderFns }